import mutations from './staff.mutations'
import actions from './staff.actions'
import getters from './staff.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
